import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import Checkbox from "../../../../../components/Checkbox";
import EventList from "./EventList";
import { PimsProject, PimsEvent } from "../types";

interface ProjectCardProps {
  project: PimsProject;
  events: PimsEvent[];
  isSelected: boolean;
  isExpanded: boolean;
  selectedEvents: Set<string>;
  onProjectSelection: (projectId: string, checked: boolean) => void;
  onEventSelection: (eventId: string, checked: boolean) => void;
  onToggleExpansion: (projectId: string) => void;
}

export default function ProjectCard({
  project,
  events,
  isSelected,
  isExpanded,
  selectedEvents,
  onProjectSelection,
  onEventSelection,
  onToggleExpansion,
}: ProjectCardProps) {
  return (
    <div>
      {/* Project row */}
      <div className="flex items-start gap-2 py-2">
        {/* Arrow icon */}
        <button
          onClick={() => onToggleExpansion(project.id)}
          className="p-1 hover:bg-secondary rounded transition-colors"
          type="button"
        >
          {isExpanded ? (
            <ChevronDownIcon className="h-4 w-4" />
          ) : (
            <ChevronRightIcon className="h-4 w-4" />
          )}
        </button>

        {/* Project checkbox */}
        <Checkbox
          checked={isSelected}
          onChange={(checked) => onProjectSelection(project.id, checked)}
        />

        {/* Project label */}
        <div className="flex flex-col">
          <div className="text-xs text-accent">Projet</div>
          <div className="font-medium">{project.label}</div>
          <div className="text-xs text-secondary">
            {events.length} évènements
          </div>
        </div>
      </div>

      {/* Events list (shown when expanded) */}
      <AnimatePresence>
        {isExpanded && events.length > 0 && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.1, ease: "easeInOut" }}
            className="ml-6 pb-2 overflow-hidden"
          >
            <EventList
              events={events}
              selectedEvents={selectedEvents}
              onEventSelection={onEventSelection}
              size="small"
              gridCols="grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
